import React, { Component } from 'react';
import { BrowserRouter} from 'react-router-dom';
/* Font awesome icons */
import { library } from '@fortawesome/fontawesome-svg-core';
import { faGlobeAmericas, faUser, faShippingFast, faFilter, faHourglass } from  '@fortawesome/free-solid-svg-icons';
/* Components */
import PageHeader from './components/PageHeader';
import RightSection from './components/RightSection';
import NavBar from './components/NavBar';
/* Util functions */
import TimeRange from './util/getTimeRange';
import { ProgresBar } from './util/progressBar';
import {clearCache} from './util/sessionStorageController';
import server from './util/apiService';

library.add(faGlobeAmericas, faShippingFast, faUser, faFilter, faHourglass);
export default class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showNavBar: this.decideNavBarState(),
      timeSelectorValue: 'Q3',
      data: [],
      allShipperData: [],
      dataYear: this.props.year || '16',
      shipper: 'Greenway Carriers',
      theme: 'dark'
    }
  }

  render() {
    let pageHeaderProps = {
      showNavBar: this.state.showNavBar,
      handleNavBar: this.handleNavBar,
      timeSelectorValue: this.state.timeSelectorValue,
      handleFilterDropdown: this.handleFilterDropdown,
      handleDataChange: this.handleDataChange,
      handleAllShipperData: this.handleAllShipperData,
      theme: this.state.theme,
      handleTheme: this.handleTheme
    }, 
    rightSectionProps = {
      timeSelectorValue: this.state.timeSelectorValue,
      handleFilterDropdown: this.handleFilterDropdown,
      data: this.state.data,
      allShipperData: this.state.allShipperData,
      theme: this.state.theme
    };

    return (
      <BrowserRouter>
        <div className="App">
          <PageHeader pageHeaderProps={pageHeaderProps}/>
            <div className="container-fluid">
              <div className="row flex-xl-no-wrap">
                <NavBar showNavBar={this.state.showNavBar} handleNavBar={this.handleNavBar}/>
                <RightSection rightSectionProps={rightSectionProps}/>
              </div>
            </div>
        </div>
      </BrowserRouter>
    );
  }

  componentDidMount() {
    // event listener for hiding nav-bar on resizing.
    window.addEventListener('resize', this.resize);

    // fetch data from server when component mount.
    this.fetchData();
  }

  componentWillUnmount() {
    // remove the eventlistener when component unmount.
    window.removeEventListener('resize', this.resize)
  }
  /**
   * Fetching data from server using axios call.
   */
  fetchData() {
    // clear sessionStorage on initial loading.
    clearCache();

    // Page Progress bar starts
    ProgresBar.start(0.4);

    // Start and End time is decided using TimeRage class
    var timeRangeObject = new TimeRange(this.state.dataYear).getTimeRange(this.state.timeSelectorValue);

    // Axios call is made with start and end date as a query parameter.
    server.get('/api?startTime=' + timeRangeObject.startTime + '&endTime=' + timeRangeObject.endTime + '&shipper=Greenway%20Carriers')
    .then((response) => {

      //change the data state and store data in sessionStorage when response is recieved
      this.setState({data: response.data});
      window.sessionStorage[this.state.timeSelectorValue] = JSON.stringify(response.data, null, 4);

      // stop the progress bar when loading is complete
      ProgresBar.stop();
    })
    .catch((error) => {
      console.log(error);
    });
    server.get('/api/all?startTime=' + timeRangeObject.startTime + '&endTime=' + timeRangeObject.endTime)
    .then((response) => {
      this.setState({allShipperData: response.data});
      window.sessionStorage['allShipperData' + this.state.timeSelectorValue] = JSON.stringify(response.data, null, 4);
    })
    .catch((error) => {
      console.log(error);
    });
  }
  /**
  * This function is passed to child component to control theme state of App.
  */
  handleTheme = (value) => {
    this.setState({theme: value});
  }
  /**
  * This function is passed to child component to control display state of NavBar.
  */
  handleNavBar = (value) => {
    this.setState({showNavBar: value});
  }
  /**
  * This function is passed to child component to control data and dropdown filter value state.
  */
  handleFilterDropdown = (timeSelectorValue, data) => {
    this.setState({timeSelectorValue: timeSelectorValue, data: data});
  }
  /**
  * This function is passed to child component to control shipper data state.
  */
  handleAllShipperData = (allShipperData) => {
    this.setState({allShipperData: allShipperData});
  }

  handleDataChange = (value) => {
    this.setState({data: value});
  }
  /**
   * This function is called every time app is resized which decide navbar display state
   */
  resize = () => {
    this.setState({showNavBar: this.decideNavBarState()});
  }
  /**
  * Function to decide default display state of NavBar
  * Nav be should be shown by default on larger screen (laptops, tablets) and should be hidden in smaller devices
  */
  decideNavBarState = () => {
    if(window.innerWidth > 576) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.js